// extracted by mini-css-extract-plugin
module.exports = {"loader":"ReadProgress_loader__ZGAVM","shimmer":"ReadProgress_shimmer__QXZhP"};